import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { dynamicElementsPriceRange } from '@epicuro-next/constants/dynamic-elements';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { FloatRange } from 'graphql-api/gql-api-interfaces';

@DynamicComponentRegister(dynamicElementsPriceRange, true)
@Component({
  selector: 'atx-price-range',
  templateUrl: './price-range.component.html',
  styleUrls: ['./price-range.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PriceRangeComponent {
  public readonly notAvailable = $localize`:Config Strip|Price not available label@@priceNotAvailable:n/a`;

  @Input() public priceRange: FloatRange | null = null;
}
